<div class="valide-screen">
  <div class="grain"></div>

  <div class="card">

    <div class="wordmark">
      <span class="wordmark-la">La</span>
      <span class="wordmark-base">BASE</span>
    </div>

    <div class="seal-wrapper">
      <div class="seal-ring seal-ring-outer"></div>
      <div class="seal-ring seal-ring-mid"></div>
      <div class="seal-body">
        <ion-icon name="checkmark-outline" class="seal-icon"></ion-icon>
      </div>
      <div class="burst burst-1"></div>
      <div class="burst burst-2"></div>
    </div>

    <h1 class="heading">Accès <em>accordé</em></h1>
    <p class="subtext">Votre statut étudiant a été validé.<br>Bienvenue à La BASE&nbsp;!</p>

    <div class="progress-bar">
      <div class="progress-fill"></div>
    </div>

  </div>
</div>
